import { useWithdrawalRiskPolicy } from '../../features/settings';
import { formatDateTime } from '../../lib/format';

export function WithdrawalRiskPolicyPage() {
  const {
    data,
    loading,
    saving,
    error,
    sameTargetUserThreshold,
    setSameTargetUserThreshold,
    telegramEnabled,
    setTelegramEnabled,
    telegramBotToken,
    setTelegramBotToken,
    telegramChatID,
    setTelegramChatID,
    save,
    reload,
  } = useWithdrawalRiskPolicy();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="h-6 w-6 border-2 border-gray-300 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="py-20 text-center">
        <p className="text-sm text-red-500 mb-3">{error}</p>
        <button onClick={reload} className="text-sm text-primary hover:underline">
          重试
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-2xl space-y-6">
      <p className="text-sm text-gray-500">
        配置同一提现账号关联用户数阈值和 Telegram Channel 告警。红包提现按 openid 聚合。
      </p>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            同提现账号关联用户阈值
          </label>
          <input
            type="number"
            min={0}
            value={Number.isNaN(sameTargetUserThreshold) ? '' : sameTargetUserThreshold}
            onChange={(e) => {
              const value = e.target.value;
              setSameTargetUserThreshold(value === '' ? Number.NaN : Number(value));
            }}
            className="h-9 w-60 rounded-md border border-gray-300 px-3 text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
          <p className="mt-2 text-xs text-gray-400">0 表示不发送复用告警。</p>
        </div>

        <label className="flex h-9 items-center gap-2 text-sm font-medium text-gray-700">
          <input
            type="checkbox"
            checked={telegramEnabled}
            onChange={(e) => setTelegramEnabled(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary/50"
          />
          启用 Telegram 告警
        </label>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Telegram Bot Token
          </label>
          <input
            type="password"
            value={telegramBotToken}
            placeholder={data?.telegram_token_configured ? '已配置，留空则不修改' : '请输入 Bot Token'}
            onChange={(e) => setTelegramBotToken(e.target.value)}
            className="h-9 w-full rounded-md border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Telegram Chat ID
          </label>
          <input
            value={telegramChatID}
            onChange={(e) => setTelegramChatID(e.target.value)}
            className="h-9 w-full rounded-md border border-gray-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
          />
        </div>

        <div>
          <button
            onClick={save}
            disabled={saving}
            className="inline-flex items-center gap-2 bg-primary text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-primary-hover disabled:opacity-50 transition-colors"
          >
            {saving && (
              <span className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            )}
            保存
          </button>
        </div>
      </div>

      {data && (
        <div className="pt-4 border-t border-gray-200 text-xs text-gray-400 space-y-1">
          <p>Bot Token：{data.telegram_token_configured ? '已配置' : '未配置'}</p>
          <p>最后更新：{formatDateTime(data.updated_at)}</p>
          {data.updated_by != null && <p>操作人 ID：{data.updated_by}</p>}
        </div>
      )}
    </div>
  );
}
